var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"empty-area no-content"}),_c('p',{staticClass:"text-center"},[_vm._v("Nothing for now to show you!")])])}]

export { render, staticRenderFns }